import LiberationSansRegular from "./LiberationSans-Regular.woff2";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const LiberationFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: LiberationSansRegular,
  },
];
